import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";
import "./Layout.css";
import LanguageSelector from "../pages/Languages/LanguageSelector";
import { LanguageContext } from "../pages/Languages/LanguageContext";
import Sidebar from "./Sidebar/Sidebar";
import "../components/Sidebar/sidebar.css";

const Layout = ({ children }) => {
  const { profile } = useSelector((state) => state.auth);
  const role = useSelector((state) => state?.auth?.user?.role);
  console.log("role", role);

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const toggleNavbar = () => setIsNavbarOpen((prev) => !prev);

  const isSidebarVisible = useSelector(
    (state) => state.collapse.isSidebarVisible,
  );

  const dispatch = useDispatch();

  const { t } = useContext(LanguageContext);
  const location = useLocation();
  const isWebsitePath = location.pathname === "/website";
  const mobileDropdownRef = useRef(null);
  const desktopDropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown &&
        !mobileDropdownRef.current?.contains(event.target) &&
        !desktopDropdownRef.current?.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    window.location.reload();
  };

  return (
    <div>
      <div
        className="navbar-expand-lg  navbar-light fixed-top"
        style={{ zIndex: "99999" }}
      >
        <LanguageSelector />
      </div>

      <>
        <div
          className="pt-3 pl-10  dashboard-header  vh-100 d-flex gap-0 align-items-start "
          style={{ width: "100%" }}
        >
          {isSidebarVisible && (
            <div
              className="col-xl-2 col-2 d-none d-lg-block"
              style={{ marginTop: "1px", border: "2px solid yellow" }}
            >
              <Sidebar />
            </div>
          )}

          <div
            className={` rounded-4  ${
              isSidebarVisible ? "col-12 ps-0" : "col-11"
            }`}
            style={{ transition: "all 0.3s ease" }}
          >
            <nav
              className="  shadow-lg dashboard-navbar navbar-light col-12 colxl-9  bg-white mb-5 position-fixed top-0 "
              style={{
                marginTop: "31px",
                height: "60px",
                zIndex: "9999",
              }}
            >
              <div
                className="container-fluid d-flex justify-content-between align-items-center"
                style={{
                  height: "100%",
                }}
              >
                <div
                  className="d-flex gap-1  justify-content-between align-items-center"
                  style={{ width: "100%" }}
                >
                  <div className="fs-5 text-danger">
                    {role === "company" ? t.companyportal : t.deliveryperson}
                  </div>
                  <div className="d-flex gap-3 align-items-center jutify-content-end">
                    <button
                      className=" d-lg-none border-0 d-flex align-items-center justify-content-center  rounded-2 bg-light text-info m-3 z-1030"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent the document click handler from firing
                        toggleNavbar();
                      }}
                      style={{ zIndex: 1030, width: "25px", height: "25px" }}
                    >
                      <i
                        className={`bi ${isNavbarOpen ? "bi-x" : "bi-list"}`}
                        style={{ fontSize: "1rem", fontWeight: "bold" }}
                      ></i>
                    </button>
                    {/* Avatar */}
                    <li
                      className="d-flex d-lg-none dropdown"
                      ref={mobileDropdownRef}
                    >
                      <img
                        src="https://placehold.co/600x400"
                        alt="avatar"
                        className="rounded-circle"
                        onClick={() => setShowDropdown(!showDropdown)}
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                      />
                      <ul
                        className={`dropdown-menu mt-2 ${
                          showDropdown ? "show" : ""
                        }`}
                        style={{
                          minWidth: "250px",
                          position: "absolute",
                          top: "80%",
                          right: "0%",
                          border: "none",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                        }}
                      >
                        <li className="mb-3">
                          <Link
                            to="/welcome"
                            className={`dropdown-item ${
                              location.pathname === "/welcome" ? "active" : ""
                            }`}
                            onClick={() => setShowDropdown(false)}
                          >
                            {t.welcome}, {profile?.username}
                          </Link>
                        </li>
                        <li className="d-flex justify-content-center mb-3 align-items-center">
                          <button
                            onClick={() => {
                              handleLogout();
                              setShowDropdown(false);
                            }}
                            className="dropdown-item text-info p-2  rounded-2 d-flex justify-content-center align-items-center bg-light"
                            style={{ width: "80px" }}
                          >
                            {t.logout}
                          </button>
                        </li>
                      </ul>
                    </li>
                  </div>
                </div>
                <div
                  className={`collapse  ${isNavbarOpen ? "show" : ""}`}
                  id="navbarNav"
                ></div>
                {/* Avatar */}
                <li
                  className="d-none d-lg-flex justify-content-end dropdown"
                  ref={desktopDropdownRef}
                >
                  <img
                    src="https://placehold.co/600x400"
                    alt="avatar"
                    className="rounded-circle me-3"
                    onClick={() => setShowDropdown(!showDropdown)}
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                  />
                  <ul
                    className={`dropdown-menu mt-2 ${
                      showDropdown ? "show" : ""
                    }`}
                    style={{
                      minWidth: "250px",
                      position: "absolute",
                      top: "80%",
                      right: "0%",
                      border: "none",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <li className="mb-3">
                      <Link
                        to="/welcome"
                        className={`dropdown-item ${
                          location.pathname === "/welcome" ? "active" : ""
                        }`}
                        onClick={() => setShowDropdown(false)}
                      >
                        {t.welcome}, {profile?.username}
                      </Link>
                    </li>
                    <li className="d-flex justify-content-center mb-3 align-items-center">
                      <button
                        onClick={() => {
                          handleLogout();
                          setShowDropdown(false);
                        }}
                        className="dropdown-item rounded-2 p-2 d-flex justify-content-center align-items-center text-info bg-light"
                        style={{ width: "80px" }}
                      >
                        {t.logout}
                      </button>
                    </li>
                  </ul>
                </li>
              </div>{" "}
            </nav>
            <div
              className={`mobile-menu-top position-fixed start-0 w-100 bg-white text-dark ${
                isNavbarOpen ? "menu-open" : "menu-closed"
              } d-lg-none`}
              style={{
                zIndex: 99,
                top: "90px",
                transition: "transform 0.3s ease-in-out",
                transform: isNavbarOpen
                  ? "translateY(0%)"
                  : "translateY(-100%)",
              }}
            >
              <ul
                className="list-unstyled d-flex flex-column justify-content-center align-items-center"
                style={{ marginTop: "10px" }}
              >
                {role && role !== "partner" && (
                  <li className="mb-3">
                    <Link
                      to="/dashboard"
                      onClick={toggleNavbar}
                      className="fw-bold text-light text-decoration-none"
                      style={{ fontSize: "14px" }}
                    >
                      {t.dashboard}
                    </Link>
                  </li>
                )}
                {role && role !== "partner" && (
                  <li className="mb-3">
                    <Link
                      to="/delivery-request"
                      onClick={toggleNavbar}
                      className="fw-bold text-light text-decoration-none"
                      style={{ fontSize: "14px" }}
                    >
                      {t.deliveryrequest}
                    </Link>
                  </li>
                )}
                <li className="mb-3">
                  <Link
                    to="/my-deliveries"
                    onClick={toggleNavbar}
                    className="fw-bold text-light text-decoration-none"
                    style={{ fontSize: "14px" }}
                  >
                    {t.mydeliveries}
                  </Link>
                </li>
                {role && role !== "partner" && (
                  <li className="mb-3">
                    <Link
                      to="/delivery-person"
                      onClick={toggleNavbar}
                      className="fw-bold text-light text-decoration-none"
                      style={{ fontSize: "14px" }}
                    >
                      {t.deliveryperson}
                    </Link>
                  </li>
                )}
                <li className="mb-3">
                  <Link
                    to="/profile"
                    onClick={toggleNavbar}
                    className="fw-bold text-light text-decoration-none"
                    style={{ fontSize: "14px" }}
                  >
                    {t.profile}
                  </Link>
                </li>
                {role && role !== "partner" && (
                  <li className="mb-3">
                    <Link
                      to="/delivery-settings"
                      onClick={toggleNavbar}
                      className="fw-bold text-light text-decoration-none"
                      style={{ fontSize: "14px" }}
                    >
                      {t.deliverySettings}
                    </Link>
                  </li>
                )}
              </ul>
            </div>

            {/* Main Content */}
            <main
              className="bg-info p-4  right-main-content position-fixed overflow-auto  "
              style={{
                marginTop: "90px",
                height: "auto",
                maxHeight: "84.5vh",
              }}
            >
              {children}
            </main>
          </div>
        </div>
      </>
    </div>
  );
};

export default Layout;
